<div *ngIf="form" [formGroup]="form" class="d-flex flex-column gap-4">
  <div class="d-flex gap-2 align-items-center">
    <app-checkbox-input formControlName="hasSigningAuthority" [controlId]="controlIdPrefix + 'hasSigningAuthority'" />
    <app-form-option-label [labelFor]="controlIdPrefix + 'hasSigningAuthority'" i18n
      >Has Signing Authority</app-form-option-label
    >
  </div>
  <div class="form-grid">
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="controlIdPrefix + 'primaryFirstName'" i18n>First Name</label>
      <app-text-input
        formControlName="firstName"
        [controlId]="controlIdPrefix + 'primaryFirstName'"
        [error]="formSubmitted && form.controls.firstName.invalid" />
      <app-form-error
        *ngIf="formSubmitted && form.controls.firstName.invalid"
        [errors]="form.controls.firstName.errors"
        [customErrorMessages]="customErrorMessages.firstName" />
    </div>
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="controlIdPrefix + 'primaryLastName'" i18n>Last Name</label>
      <app-text-input
        formControlName="lastName"
        [controlId]="controlIdPrefix + 'primaryLastName'"
        [error]="formSubmitted && form.controls.lastName.invalid" />
      <app-form-error
        *ngIf="formSubmitted && form.controls.lastName.invalid"
        [errors]="form.controls.lastName.errors"
        [customErrorMessages]="customErrorMessages.lastName" />
    </div>
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="controlIdPrefix + 'primaryJobTitle'" i18n>Job Title</label>
      <app-text-input formControlName="jobTitle" [controlId]="controlIdPrefix + 'primaryJobTitle'" />
      <div class="form-input-hint" i18n>Optional</div>
    </div>
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="controlIdPrefix + 'primaryEmail'" i18n>Work Email Address</label>
      <app-email-input
        formControlName="email"
        [controlId]="controlIdPrefix + 'primaryEmail'"
        [error]="formSubmitted && form.controls.email.invalid" />
      <app-form-error
        *ngIf="formSubmitted && form.controls.email.invalid"
        [errors]="form.controls.email.errors"
        [customErrorMessages]="customErrorMessages.email" />
    </div>
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="controlIdPrefix + 'primaryPhoneNumber'" i18n>Primary Phone Number</label>
      <app-phone-country-code
        [formGroup]="form"
        [countryCodes]="countryCodeDropdowns"
        [controlId]="controlIdPrefix + 'primaryPhoneNumber'"
        [phoneNumberControlName]="'phoneNumber'"
        [countryCodeControlName]="'phoneNumberCountryCode'" />
      <app-form-error
        *ngIf="formSubmitted && form.controls.phoneNumber.invalid"
        [errors]="form.controls.phoneNumber.errors"
        [customErrorMessages]="customErrorMessages.phoneNumber" />
    </div>
  </div>

  <hr class="m-0" />

  <app-international-address-form-grid
    [controlIdPrefix]="controlIdPrefix + 'primaryContactAddress'"
    [form]="form.controls.address"
    [formSubmitted]="formSubmitted" />
</div>
